import './styles/index.scss';
import { AppProvider } from './providers';
import { AppRoutes } from './routes';
import 'moment/locale/es';
import useMomentLocale from './hooks/useMomentLocale';
import useDateFnsLocale from './utils/useDateFnsLocale';
import { setDefaultLocale, registerLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// Import locales (react-datepicker)
import { es } from 'date-fns/locale/es';
import { enUS } from 'date-fns/locale/en-US';

// Register locales (react-datepicker)
registerLocale('es', es);
registerLocale('en', enUS);

export default function App() {
  const { i18n } = useTranslation();
  useMomentLocale();
  useDateFnsLocale();

  useEffect(() => {
    // Update react-datepicker locale when i18next language changes
    setDefaultLocale(i18n.language ? i18n.language : 'en');
  }, [i18n.language]);

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}
